import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { FileUpload } from '../model/fileUpload';
import { HttpClient } from '@angular/common/http';
import { FileUploadSerializer } from '@app/model/serializer/fileUpload-serializer';
import { environment } from '@environments/environment';
@Injectable({ providedIn: 'root' })
export class FileUploadService extends ApiService<FileUpload> {

  constructor(httpClient: HttpClient) {
    super(httpClient,
      environment.apiUrl,
      'upload-file',
      new FileUploadSerializer());
  }

}
